import React from 'react';
import { createStackNavigator, TransitionPresets } from '@react-navigation/stack';
import { routes } from './routes';
import { WELCOME_SCREEN, HOME_PAGE } from './routes';
import { useEffect, useState } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useSelector } from 'react-redux';

const Stack = createStackNavigator();

export const HomeNavigator = () => {
  const { webAppWidgetsInfo } = useSelector((state) => state.deviceConfigSlice);
  const screenInfoAfterLoader = webAppWidgetsInfo?.screenInfoAfterLoader;

  const [initialRoute, setInitialRoute] = useState(null);

  const { isLoggedIn, shownWelcomeScreen } = useSelector(state => state.appConfigSlice)
  const { isBookingFound, bookingData } = useSelector(state => state.checkInSlice.bookingStatus);


  const checkShowWelcomeScreen = () => {
    try {

      if (screenInfoAfterLoader?.showAfterScreen && !shownWelcomeScreen) {

        if ((isLoggedIn || isBookingFound) && screenInfoAfterLoader.showAfterLogin) {
          setInitialRoute(WELCOME_SCREEN);
          return;
        }

        if (!isLoggedIn && !isBookingFound) {
          setInitialRoute(WELCOME_SCREEN);
          return;
        }
      }

      setInitialRoute(HOME_PAGE)
    } catch (error) {
      setInitialRoute(HOME_PAGE)
      console.error('Error checking welcome screen display:', error);
    }
  };

  useEffect(() => {
    checkShowWelcomeScreen();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  // Render a loading view until initialRoute is set
  if (initialRoute === null) {
    return null; // Or a loading spinner, or a temporary screen
  }

  return (
    <Stack.Navigator screenOptions={{ headerShown: false, cardStyle: { flex: 1 }, ...TransitionPresets.SlideFromRightIOS }} initialRouteName={initialRoute}>
      {routes.map((iterator) => (
        <Stack.Screen
         key={iterator.name}
         name={iterator.name}
         component={iterator.component}
         options={iterator.options} 
       />
      ))}
    </Stack.Navigator>
  );
};
